import React from "react"
import { Redirect } from "react-router-dom"





import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"



// Authentication related pages
// import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"



import Login from '../Auth/Login'
import Register from '../Auth/Register'
import Home from '../Layout/Home'
import JobDescription from "../Layout/JobDescription";
import JobListing from "../Layout/JobListing";
import About from "../Layout/About";
import Faq from "../Layout/Faq";
import Service from "../Layout/Service";
import Contact from "../Layout/Contact";
import BlogList from "../Layout/blogs/BlogList";
import ClientPage from "../Layout/ClientPage"
import QuickAdd from "../Auth/QuickAdd"
import BlogDetail from "../Layout/blogs/BlogDetail"
import BlogDetail1 from "../Layout/blogs/BlogDetail1"
import BlogDetail2 from "../Layout/blogs/BlogDetail2"

const userRoutes = [

  { path: "/", component: Home },
  { path: "/about", component: About },
  { path: "/faq", component: Faq },
  { path: "/service", component: Service },
  { path: "/contact", component: Contact },
  { path: "/blog-list", component: BlogList },
  { path: "/the-future-of-Work-why-apprenticeships-will-be-key-to-bridging-the-skills-gap", component: BlogDetail },
  { path: "/from-learning-to-earning-the-benefits-of-apprenticeships-for-young-professional", component: BlogDetail1 },
  { path: "/how-apprenticeship-training-is-revolutionizing-the-tech-industry", component: BlogDetail2 },
  { path: "/opportunity/:id/:name", component: JobDescription },
  { path: "/opportunity/:id/:name/:temp", component: JobDescription },
  { path: "/opportunity/:id/:name/:temp/:temp", component: JobDescription },
  { path: "/job-listing", component: JobListing },
  { path: "/clients", component: ClientPage },


  { path: "/", exact: true, component: () => <Redirect to="/" /> },
]

const authRoutes = [
  { path: "/quick-registration", component: QuickAdd },
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/register", component: Register },
  { path: "/pages-404", component: Pages404 },
  { path: "/pages-500", component: Pages500 },
]

export { userRoutes, authRoutes }